import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AcademyPage from '../Pages/AcademyPage'
import CartPage from '../Pages/CartPage'
import FavoritePage from '../Pages/FavoritePage'
import HomePage from '../Pages/HomePage'
import ProductPage from '../Pages/ProductPage'
import ProductSinglePage from '../Pages/ProductSinglePage'
import ProfilePage from '../Pages/ProfilePage'
import LoginPage from '../Pages/registration/LoginPage'
import SignUpPage from '../Pages/registration/SignUpPage'
import ProtectedRoutes from './ProtectedRoutes'

function MainRoute() {
	return (
		<Routes>
			<Route path="/" element={<HomePage />} />
			<Route path="/product" element={<ProductPage />} />
			<Route path="/product/:id" element={<ProductSinglePage />} />
			<Route path="/academy" element={<AcademyPage />} />
			<Route path="/cart" element={<CartPage />} />
			<Route path="/profile" element={<ProtectedRoutes><ProfilePage /></ProtectedRoutes>} />

			<Route path="/login" element={<LoginPage />} />
			<Route path="/signup" element={<SignUpPage />} />
		</Routes>
	)
}

export default MainRoute